import { Box } from "@mui/material";

import { MOBILE_STATUS_SCRIM_ZINDEX, mobileSafeAreaTop } from "~/components/mobile/mobileChrome";
import useIsStandaloneDisplay from "~/pwa/useIsStandaloneDisplay";

const StatusBarScrim = () => {
	const isStandalone = useIsStandaloneDisplay();
	if (!isStandalone) return null;

	return (
		<Box
			aria-hidden
			sx={{
				bgcolor: "background.paper",
				height: mobileSafeAreaTop,
				left: 0,
				pointerEvents: "none",
				position: "fixed",
				right: 0,
				top: 0,
				zIndex: MOBILE_STATUS_SCRIM_ZINDEX
			}}
		/>
	);
};

export default StatusBarScrim;
